/**
 * enum of all pie graph events
 */
export var Pie;

(function (Pie) {
  Pie["SLICE_MOUSEOVER"] = "pie-slice-mouseover";
  Pie["SLICE_MOUSEMOVE"] = "pie-slice-mousemove";
  Pie["SLICE_CLICK"] = "pie-slice-click";
  Pie["SLICE_MOUSEOUT"] = "pie-slice-mouseout";
})(Pie || (Pie = {}));
/**
 * enum of all bar graph events
 */


export var Bar;

(function (Bar) {
  Bar["BAR_MOUSEOVER"] = "bar-mouseover";
  Bar["BAR_MOUSEMOVE"] = "bar-mousemove";
  Bar["BAR_CLICK"] = "bar-click";
  Bar["BAR_MOUSEOUT"] = "bar-mouseout";
})(Bar || (Bar = {}));
/**
 * enum of all scatter graph events
 */


export var Scatter;

(function (Scatter) {
  Scatter["SCATTER_MOUSEOVER"] = "scatter-mouseover";
  Scatter["SCATTER_MOUSEMOVE"] = "scatter-mousemove";
  Scatter["SCATTER_CLICK"] = "scatter-click";
  Scatter["SCATTER_MOUSEOUT"] = "scatter-mouseout";
})(Scatter || (Scatter = {}));
/**
 * enum of all line graph events
 */


export var Line;

(function (Line) {
  Line["POINT_MOUSEOVER"] = "scatter-mouseover";
  Line["POINT_MOUSEMOVE"] = "scatter-mousemove";
  Line["POINT_CLICK"] = "scatter-click";
  Line["POINT_MOUSEOUT"] = "scatter-mouseout";
})(Line || (Line = {}));